module.exports = __webpack_public_path__ + "static/media/effet3.b04f44b5.ogg";